import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import locale from 'element-ui/lib/locale/lang/zh-CN'
import "element-ui/lib/theme-chalk/index.css";
import http from "./api/http.js";
import api from "./api/api.js";


import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

//api接口表全局挂载
Vue.prototype.$api = api;
//接口请求全局挂载
Vue.prototype.$http = http;

Vue.config.productionTip = false
// set ElementUI lang to EN
Vue.use(ElementUI, { locale });
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
